import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Paper,
  Typography,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import React from "react";
import Loader from "../../../../../components/Loader";
import DataAdminTable from "../../../../../components/DataAdminTable";
import { TableWrapper } from "../utils";
import { useContactsManagement } from "../hooks/useContactsManagement";

function ContactsManagement({
  selectedWell,
  isEditMode = false,
  selectedWellLabel,
}) {
  const {
    isLoading,
    error,
    refetch,
    state,
    setter,
    CONTACTS_MANAGEMENT_TABLE_COLUMNS,
  } = useContactsManagement(selectedWell);

  if (error) return "An error has occurred: " + error.message;
  return (
    <>
      {isLoading && (
        <Paper style={{ width: "100%", margin: "8px 0" }}>
          <Loader />
        </Paper>
      )}
      <Accordion defaultExpanded={isEditMode} disabled={!selectedWell}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Box style={{ width: "100%" }}>
            <Typography variant="h3">{`Edit Owner Info ${
              selectedWellLabel ? `(${selectedWellLabel})` : ""
            }`}</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <TableWrapper>
            <DataAdminTable
              canAdd={false}
              isDeletable={false}
              pageSize={10}
              isLoading={isLoading}
              label="TITLE"
              columns={CONTACTS_MANAGEMENT_TABLE_COLUMNS}
              data={state}
              height="300px"
              updateHandler={setter}
              endpoint="list-wells-associated-contacts"
              ndxField="ndx"
              selectedNdx={selectedWell}
              handleRefresh={refetch}
              search={false}
            />
          </TableWrapper>
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export default ContactsManagement;
